function parse(queryString: string): Record<string, string> {
    const query: Record<string, string> = {};

    const pairs = (queryString.startsWith('?') ? queryString.substr(1) : queryString).split('&');

    for (const pairsValue of pairs) {
        const [keyIn, valueIn] = pairsValue.split('=') as (string | undefined)[];
        if (keyIn !== undefined && valueIn !== undefined) {
            const key = decodeURIComponent(keyIn);
            const value = decodeURIComponent(valueIn) || '';
            query[key] = value;
        }
    }
    return query;
}

function assemble(
    queryArgs: Record<string, string | number | boolean>,
    questionMarkPrefix = true,
): string {
    const strPairs: string[] = [];

    for (const [key, value] of Object.entries(queryArgs)) {
        const encodedStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        strPairs.push(encodedStr);
    }

    return (questionMarkPrefix ? '?' : '') + strPairs.join('&');
}

export default Object.freeze({
    parse,
    assemble,
});
